const manutencao_estimativa_matricula = {
  path: "/manutencao-estimativa-matricula",
  redirect: "/manutencao-estimativa-matricula",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Manutencão Estimativa Matrícula",
  },
  children: [
    {
      path: "/manutencao-estimativa-matricula",
      name: "manutencao-estimativa-matricula",
      component: () =>
        import(
          "@/views/ManutencaoEstimativaMatricula/ManutencaoEstimativaMatriculaHome.vue"
        ),
    },
    {
      path: "/manutencao-estimativa-matricula-novo/:rede_ensino/:municipio_id/:coordenadoria_id/:escola_id/:tipo_estimativa",
      name: "manutencao-estimativa-matricula-novo",
      component: () =>
        import(
          "@/views/ManutencaoEstimativaMatricula/ManutencaoEstimativaMatriculaCreate.vue"
        ),
    },
    {
      path: "/manutencao-estimativa-matricula-edit/:id/:coordenadoria_id",
      name: "manutencao-estimativa-matricula-edit",
      component: () =>
        import(
          "@/views/ManutencaoEstimativaMatricula/ManutencaoEstimativaMatriculaUpdate.vue"
        ),
    },
  ],
};

export { manutencao_estimativa_matricula };
